<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<div *ngFor="let category of fieldKeys">
  <span class="category-header">{{ category }}</span>
  <div *ngFor="let f of fields2[category]" class="adv-settings">
    <!-- Boolean toggle setting -->
    <div *ngIf="f.type === 'boolean'">
      <mat-slide-toggle
        color="primary"
        [disabled]="f.disabled"
        [checked]="f.value"
        (change)="f.onToggle($event.checked)">
        {{ f.name }}
      </mat-slide-toggle>
      <mat-icon
        inline
        aria-hidden="false"
        aria-label="Help"
        *ngIf="f.help"
        matTooltip="{{ f.help }}"
        #tooltip="matTooltip">
        help
      </mat-icon>
      <mat-icon
        inline
        aria-hidden="false"
        aria-label="Help"
        *ngIf="f.impactsResultCount"
        class="report-problem-icon"
        matTooltip="This setting might impact the amount of results. It may happen that you won't get any results if you change this setting. In this case, simply switch it back to its default state."
        #tooltip="matTooltip">
        report_problem
      </mat-icon>
    </div>

    <!-- Dropdown setting -->
    <div *ngIf="f.type === 'dropdown'" class="dropdown-setting">
      <!-- Toggleable dropdown -->
      <div class="dropdown-header">
        <mat-slide-toggle
          color="primary"
          [disabled]="f.disabled"
          [checked]="f.isEnabled"
          (change)="f.onToggle && f.onToggle($event.checked)">
          <span class="dropdown-label">{{ f.name }}</span>
        </mat-slide-toggle>
        <mat-select
          [value]="f.value"
          [disabled]="f.disabled || !f.isEnabled"
          (selectionChange)="f.onSelect($event.value)"
          class="dropdown-inline"
          placeholder="Select option">
          <mat-option *ngFor="let option of f.options" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
        <mat-icon
          inline
          aria-hidden="false"
          aria-label="Help"
          *ngIf="f.help"
          matTooltip="{{ f.help }}"
          #tooltip="matTooltip">
          help
        </mat-icon>
        <mat-icon
          inline
          aria-hidden="false"
          aria-label="Help"
          *ngIf="f.impactsResultCount"
          class="report-problem-icon"
          matTooltip="This setting might impact the amount of results. It may happen that you won't get any results if you change this setting. In this case, simply switch it back to its default state."
          #tooltip="matTooltip">
          report_problem
        </mat-icon>
      </div>
    </div>
  </div>
  <div class="category-spacer"></div>
</div>
